import {
  getAuth,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { create } from "zustand";
import { persist } from "zustand/middleware";
import { db } from "../services/firebase";

export const useAuthStore = create(
  persist(
    (set) => ({
      Worker: null,
      workerToken: null,
      WorkerData: null,
      isAuthenticated: false,

      login: async (email: string, password: string) => {
        const auth = getAuth();
        try {
          await setPersistence(auth, browserSessionPersistence);

          const userCredential = await signInWithEmailAndPassword(auth, email, password);
          const user = userCredential.user;
          const token = await user.getIdToken();

          set({ Worker: user, isAuthenticated: true, workerToken: token });

          const WorkerSnapshot = await getDoc(doc(db, "workers", user.uid));
          if (WorkerSnapshot.exists()) {
            set({ WorkerData: WorkerSnapshot.data() });
            await updateDoc(doc(db, "workers", user.uid), { lastLogin: new Date() });
          } else {
            set({ WorkerData: null });
          }
          return user;
        } catch (error: any) {
          console.error("Error durante el inicio de sesión:", error);
          set({ Worker: null, isAuthenticated: false, workerToken: null });
          return error;
        }
      },

      logout: async () => {
        const auth = getAuth();
        try {
          await signOut(auth);
          set({
            Worker: null,
            WorkerData: null,
            isAuthenticated: false,
            workerToken: null,
          });
        } catch (error) {
          console.error("Error durante el cierre de sesión:", error);
        }
      },

      fetchWithFreshToken: async (url: string, options: any = {}) => {
        const token = await getFreshIdToken();
        // si no hay token
        if (!token) {
          throw new Error("No se pudo obtener el token de autenticación.");
        }
        
        options.headers = {
          ...options.headers,
          Authorization: `Bearer ${token}`,
        };
        return fetch(url, options);
      },
    }),
    {
      name: "authStore",
      partialize: (state: any) => ({
        Worker: state.Worker,
        workerToken: state.workerToken,
        WorkerData: state.WorkerData,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

// Función para obtener el token de autenticación del usuario
const getFreshIdToken = async () => {
  const auth = getAuth();
  if (auth.currentUser) {
    return await auth.currentUser.getIdToken(true);
  }
  return null;
};
